import { gql } from "@apollo/client";

export const UPDATE_SESSION_RECORD = gql`mutation updateSessionRecordStatus($cId: UUID!, $sId: UUID!, $sjId: UUID!,$isRecordStart:Boolean!,$recordStarttime:Datetime) {
    updateSessionRecordStatus(
      input: {pCId: $cId, pIsRecordStsrt: $isRecordStart, pReocrdStartTime: $recordStarttime, pSessionId: $sId, pSubjectId: $sjId}
    ) {
      clientMutationId
    }
}`;

export const ADD_SESSION_PARTICIPANTS = gql`
  mutation AddSessionParticipant(
    $cId: UUID!
    $sId: UUID!
    $sjId: UUID!
    $participantId: String!
  ) {
    addSessionParticipant(
      input: {
        pCId: $cId
        pSessionId: $sId
        pSubjectId: $sjId
        pParticipantId: $participantId
      }
    ) {
      clientMutationId
    }
  }
`;

export const DELETE_SESSION_PARTICIPANT = gql`
  mutation DeleteSessionParticipant(
    $cId: UUID!
    $sId: UUID!
    $sjId: UUID!
    $participantId: String!
  ) {
    deleteSessionParticipant(
      input: {
        clientMutationId: ""
        pCId: $cId
        pSessionId: $sId
        pSubjectId: $sjId
        pParticipantId: $participantId
      }
    ) {
      clientMutationId
    }
  }
`;
